/**
 * @copyright Copyright (c) 2015, Pacific Biosciences of California, Inc.
 * @author <a href="mailto:bskinner@pacificbiosciences.com">Brian Skinner</a>
 */

import {Frame} from "../frames/frame"
import { commonTranslations } from "../translations/silos"

export const REFERENCE_FRAME = new Frame({
    endpoint: undefined, // API.nDatasets.and({$set_type: "references"}),
    properties: {
        name: {
            title: commonTranslations.name,
            description: "",
            type: "string",
            idField: "id",
            /* eslint no-template-curly-in-string: "off" */
            url: "/data-management/dataset-detail/${id}?type=references"
        },
        organism: {
            title: commonTranslations.organism,
            description: "",
            type: "string"
        },
        ploidy: {
            title: commonTranslations.ploidy,
            description: "",
            type: "string"
        },
        updatedAt: {
            title: commonTranslations.updatedAt,
            description: "",
            type: "string",
            format: "date-time"
        },
        numRecords: {
            title: commonTranslations.numRecords,
            description: "",
            type: "integer"
        },
        totalLength: {
            title: commonTranslations.totalLengthUnitless,
            description: "",
            type: "integer",
            format: "length"
        },
        createdAt: {
            title: commonTranslations.createdAt,
            description: "",
            type: "string",
            format: "date-time"
        },
        id: {
            title: commonTranslations.id,
            description: "",
            type: "string"
        },
        uuid: {
            title: commonTranslations.uuid,
            description: "",
            type: "string"
        },
        path: {
            title: commonTranslations.path,
            description: "",
            type: "string"
        },
        tags: {
            title: commonTranslations.tags,
            description: "",
            type: "string"
        },
        projectId: {
            title: commonTranslations.projectId,
            description: "",
            type: "integer"
        },
        version: {
            title: commonTranslations.version,
            description: "",
            type: "string"
        },
        md5: {
            title: commonTranslations.md5,
            description: "",
            type: "string"
        },
        createdBy: {
            title: commonTranslations.createdBy,
            description: "",
            type: "string"
        },
        comments: {
            title: commonTranslations.comments,
            description: "",
            type: "string"
        }
    }
})
